<template>


  <div id="dlnkpartners-partners" class="w-100">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <div class="position-relative overflow-hidden bg-primary">
      <div class="container position-relative z-index-2 space-top-1 space-top-md-2 space-bottom-1 space-bottom-md-2">
        <div class="w-md-80 mx-md-auto">
          <div class="mb-7">
            <h1 class="text-center text-white">{{ page.title }}</h1>
          </div>
          <p class="h4 text-center text-white">
            {{ page.title_2 }}
          </p>
        </div>
      </div>
      <figure class="position-absolute right-0 bottom-0 left-0 mb-n1">
        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
          <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
        </svg>
      </figure>
    </div>

    <!-- Stories Section -->
    <div class="container pt-4">

      <p class="" v-html="page.description"></p>

      <div class="row">

        <!-- Slider partner debut  -->
        <div class="mb-5 w-lg-95 w-xl-100 mx-auto">

          <div class="row mb-3">
            <div class="col-12 text-center">
              <a :href="'/module/dlnkpartners/partners?page_id=' + page.id"
                 class="btn btn-pill btn-primary transition-3d-hover">
                Voir tous&nbsp;<i class="fas fa-angle-right fa-sm ml-1"></i>
              </a>
            </div>
          </div>

          <div class="card p-3" v-if="carousel_open">
            <div id="partners-carousel" class="owl-carousel owl-theme">
              <div class="item" v-for="partner in partners">
                <div>
                  <a href="javascript:void(0);" data-toggle='modal' data-target='#partner_modal'>
                    <img :src="partner.logo"/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Slider partner fin  -->
      </div>

      <div class="row mb-3">
        <div class="col-12 text-center">
          <a href="/nous-contacter"
             class="btn btn-pill btn-primary transition-3d-hover">
            {{ page.join_us }} &nbsp;<i class="fas fa-angle-right fa-sm ml-1"></i>
          </a>
        </div>
      </div>


    </div>
    <!-- End Stories Section -->

  </div>
</template>

<script>

export default {

  props: ['page_id'],

  data: function () {
    return {
      message: '',
      message_type: '',

      partners: Array,
      partner: Object,
      page: Object,

      carousel_open: Boolean

    }
  },
  mounted() {
    this.step = 'pages'
    this.carousel_open = false
    this.get_page()
  },

  computed: {},

  methods: {
    close_message: function () {
      this.message = null;
    },

    open_modal: function (partner) {
      this.partner = partner
    },

    get_page: async function () {
      const _this = this;

      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/partner_pages/" + _this.page_id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.page = response.data
            _this.partners = _this.page.partners
            _this.carousel_open = true
          })
          .catch(function (error) {
            _this.message = "Erreur";
            _this.message_type = "alert-danger"
          })
          .then(function () {
            $("#partners-carousel").owlCarousel({
              loop: true,
              margin: 40,
              nav:true,
              autoplay: true,
              dots: true,
              responsive: {
                0: {
                  items: 1,
                  nav: true,
                  loop: true
                },
                600: {
                  items: 3,
                  nav: true,
                  loop: true
                },
                1000: {
                  items: 4,
                  nav: true,
                  loop: true
                }
              }
            });
              }
          );
    },
  }
}
</script>

<style scoped>

.bg-blue {
  background-color: #0049a4;
}

</style>